import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import * as api from '../api/stock-reservations';

export const useReservationsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['stock-reservations', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getReservationsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useReservation = (uuid) =>
  useQuery({
    queryKey: ['stock-reservations', uuid],
    queryFn: () => api.getReservation(uuid),
    enabled: !!uuid,
  });

export const useCreateReservation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createReservation(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stock-reservations'] }),
  });
};

export const useReleaseReservation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.releaseReservation(uuid),
    onSuccess: (_, uuid) => {
      qc.invalidateQueries({ queryKey: ['stock-reservations'] });
      qc.invalidateQueries({ queryKey: ['stock-reservations', uuid] });
      qc.invalidateQueries({ queryKey: ['products'] });
    },
  });
};

export const useFulfillReservation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => api.fulfillReservation(uuid),
    onSuccess: (_, uuid) => {
      qc.invalidateQueries({ queryKey: ['stock-reservations'] });
      qc.invalidateQueries({ queryKey: ['stock-reservations', uuid] });
      qc.invalidateQueries({ queryKey: ['products'] });
    },
  });
};
